import React from 'react';
import '../styles/formHeader.css'

function Header(props) {
  return (
		<div id="form-header-div">
			<h1 id='form-headline'>Streamline</h1>
      
			<img
					src='https://i.ibb.co/bH1Lm2w/Untitled-design-11.png'
					alt='paperplane'
					id='under-name'
				/>

		</div>
	);
}

export default Header;
